/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Email1/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Default from './Default/index'
import DefaultTag from './DefaultTag/index'
import Edit from './Edit/index'
import Email from './Email/index'
import LastModified from './LastModified/index'
import Name from './Name/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Email1({
  children,
  viewPath = "/App/Account/Content/Settings/Content/CommsEmail/Emails/Emails/Content/Email"
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let emailItemIndexValueData = fromData.useDataValue({ viewPath,
context: 'email_item',
path: 'index',
})
let constantData = 1
let aggregateData = fromAggregate.add(emailItemIndexValueData, constantData)
  return (<React.Fragment
>
<div
  data-testid="Email.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-4PsPS': dtColorsNeutral200,'--bblr-2-4PsPS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-3-4PsPS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-4-4PsPS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-5-4PsPS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-6-4PsPS': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-7-4PsPS': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-8-4PsPS': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-9-4PsPS': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mb-10-4PsPS': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--g-11-4PsPS': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Email.Horizontal"
  data-view-path={viewPath}
 style={{'--g-11-4PsPS': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Email.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-11-4PsPS': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="Email.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-12-4PsPS': dtColorsNeutral200,'--pl-7-4PsPS': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-8-4PsPS': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-9-4PsPS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-6-4PsPS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-4-4PsPS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-5-4PsPS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bblr-2-4PsPS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-3-4PsPS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontSize={16}
 weight="semibold"
 data="email_item.index"
 data={1}
 aggregate="/Data/aggregate.js add"
 text={aggregateData}
/>
</div>
<Email
  viewPath={`${viewPath}/Email`}
/>
<DefaultTag
  viewPath={`${viewPath}/DefaultTag`}
/>
</div>
<div
  data-testid="Email1.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-11-4PsPS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal2}`}
>
<Default
  viewPath={`${viewPath}/Default`}
/>
<Edit
  viewPath={`${viewPath}/Edit`}
/>
</div>
</div>
<div
  data-testid="Email1.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<LastModified
  viewPath={`${viewPath}/LastModified`}
/>
</div>
</div>
{children}
</React.Fragment>)
}